module.exports = __webpack_public_path__ + "assets/img/1_604_big.9a357cf1.jpg";